export default __webpack_public_path__ + "static/media/logo_inta.da05d33a.png";